var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('vuestic-widget',{attrs:{"header-text":'Inicio'}},[_c('h1',[_vm._v("Home")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }